import type { CSSProperties } from "react";
import type { CmsBackground } from "@/lib/api/cms-windows";

/**
 * Builduje inline CSS style z backend `CmsBackground` resolve'a.
 * Każda non-null wartość mapowana na CSS prop. Pusty obiekt gdy `bg` null.
 *
 * Po cutover 2026-05-27 helper żyje obok `variants.tsx` (single source of truth
 * dla CMS rendering) — aplikujący `<article>` w `WindowAreaView` i każdy
 * catalog variant który chce honor'ować admin-defined tło.
 *
 * Wcześniej helper był wbudowany w `WindowContainer.tsx` (kontener okna z
 * `KClear`/`KDefault`/...); ten plik przestał istnieć po drop'ie warstwy
 * kontenerów na rzecz frontend-only variants per area.
 */
export function backgroundToStyle(
  bg: CmsBackground | null | undefined,
): CSSProperties {
  if (!bg) return {};
  const style: CSSProperties = {};
  if (bg.color) style.backgroundColor = bg.color;
  if (bg.image_url) style.backgroundImage = `url(${JSON.stringify(bg.image_url)})`;
  if (bg.h_align || bg.v_align) {
    style.backgroundPosition = `${bg.h_align ?? "left"} ${bg.v_align ?? "top"}`;
  }
  if (bg.repeat) style.backgroundRepeat = bg.repeat;
  if (bg.attachment) style.backgroundAttachment = bg.attachment;
  return style;
}
